import { NgModule } from '@angular/core';
import { RatingModule } from 'primeng/rating';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { MenuModule } from 'primeng/menu';
// import { BadgeModule } from 'primeng/badge';
// import { TableModule } from 'primeng/table';
// import { SliderModule } from 'primeng/slider';
// import { ButtonModule } from 'primeng/button';
// import { StepperModule } from 'primeng/stepper';
// import { TabViewModule } from 'primeng/tabview';
// import { TooltipModule } from 'primeng/tooltip';
// import { DividerModule } from 'primeng/dividser';
// import { SkeletonModule } from 'primeng/skeleton';
// import { CarouselModule } from 'primeng/carousel';
// import { SkeletonModule } from 'primeng/skeleton';
// import { CarouselModule } from 'primeng/carousel';
// import { PasswordModule } from 'primeng/password';
// import { GalleriaModule } from 'primeng/galleria';
// import { CheckboxModule } from 'primeng/checkbox';
// import { InputTextModule } from 'primeng/inputtext';
// import { InputNumberModule } from 'primeng/inputnumber';
// import { RadioButtonModule } from 'primeng/radiobutton';
// import { ScrollPanelModule } from 'primeng/scrollpanel';
// import { ProgressBarModule } from 'primeng/progressbar';
// import { InputSwitchModule } from 'primeng/inputswitch';
// import { InputTextareaModule } from 'primeng/inputtextarea';

const primengComponents: any[] = [
  DialogModule,
  DropdownModule,
  ConfirmDialogModule,
  AccordionModule,
  RatingModule,
  ConfirmPopupModule,
  CalendarModule,
  SidebarModule,
  // GalleriaModule,
  // ButtonModule,
  // TooltipModule,
  // InputNumberModule,
  // RadioButtonModule,
  // InputTextareaModule,
  // CarouselModule,
  // SliderModule,
  // InputTextModule,
  // CheckboxModule,
  // DividerModule,
  // TableModule,
  // PasswordModule,
  // BadgeModule,
  // ScrollPanelModule,
  // ProgressBarModule,
  // ScrollPanelModule,
  // SkeletonModule,
  // StepperModule,
  // MenuModule,
  // TabViewModule,
  // InputSwitchModule,
]

@NgModule({
  declarations: [],
  imports: [
    primengComponents,

  ],
  exports: [
    primengComponents
  ]
})
export class PrimengModule { }
